import axios from 'axios';
import { ESSENTIALS_URL } from '../auth/authUtils';

const getUserDetailsById = async (id: string) => {
  const response = await axios.get(`${ESSENTIALS_URL}/cloud/web/appl/customer-management/legacy/sdk/platform/v1/organizations`, {
    params: { akaName:id },
    withCredentials: true,
  });
  return response.data;
};

const getUserDetails = async () => {
  const response = await axios.get(`${ESSENTIALS_URL}/cloud/web/appl/user-management/legacy/sdk/platform/v1/users/me`, {
    withCredentials: true,
  });
  return response.data;
};

export { getUserDetailsById };
export default getUserDetails;
